import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { createApiUrlWithPrefix } from '../config/api';

const UserCountsContext = createContext();

export const useUserCounts = () => {
  const context = useContext(UserCountsContext);
  if (!context) {
    throw new Error('useUserCounts must be used within a UserCountsProvider');
  }
  return context;
};

export const UserCountsProvider = ({ children }) => {
  const [userCounts, setUserCounts] = useState({
    personnel: 0,
    coaches: 0,
    riders: 0,
    owners: 0,
    temporary: 0,
    subscribers: 0,
    loading: true
  });

  const fetchUserCounts = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      console.log('🔄 Fetching user counts...');
      
      // Fetch all users with a high limit to get all users at once
      const response = await axios.get(createApiUrlWithPrefix('users?limit=1000&_t=' + Date.now()), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const users = response.data.users || [];
      console.log('📊 Total users fetched:', users.length);
      
      // Fetch subscribers count (only pending subscribers with status = 0)
      let subscribersCount = 0;
      try {
        const subscribersResponse = await axios.get(createApiUrlWithPrefix('subscribers?status=0'), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        subscribersCount = Array.isArray(subscribersResponse.data) ? subscribersResponse.data.length : 0;
        console.log('📊 Pending subscribers:', subscribersCount);
      } catch (error) {
        console.error('Error fetching subscribers count:', error);
      }
      
      // Count users by role
      const counts = {
        personnel: users.filter(u => u.role === 3).length, // Only Admin (exclude SuperAdmin)
        coaches: users.filter(u => u.role === 2).length,
        riders: users.filter(u => u.role === 0).length,
        owners: users.filter(u => u.role === 1).length,
        temporary: users.filter(u => u.role === 5).length,
        subscribers: subscribersCount,
        loading: false
      };
      
      console.log('📈 User counts:', counts);
      
      setUserCounts(counts);
    } catch (error) {
      console.error('Error fetching user counts:', error);
      setUserCounts(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    fetchUserCounts();
  }, []);

  const value = {
    userCounts,
    refreshUserCounts: fetchUserCounts
  };

  return (
    <UserCountsContext.Provider value={value}>
      {children}
    </UserCountsContext.Provider>
  );
};
